/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:41:57
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:44:26
 * @FilePath: \program-name\src\net\home\index.js
 */
import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {baseUrl} = config

// 用户详情
function ApiGetUserInfo (params) {
  return get(`${baseUrl}student/detail`, params);
}

// 消息详情
function ApiGetTaskList (params) {
  return post(`${baseUrl}task/list`, params);
}

// 获取播放课件的详情
function ApiGetCheckLesson (params) {
  return get(`${baseUrl}course/checkLesson`, params);
}

// 上传进度
function ApiSaveCourseProcess (params) {
  return post(`${baseUrl}course/saveCourseProcess`, params);
}

// 我的收藏
function ApiMyCollect (params) {
  return post(`${baseUrl}student/myCollect`, params);
}

// 我的收藏
function ApiStudentRecord (params) {
  return post(`${baseUrl}student/studentRecord`, params);
}

// 我的消息列表
function ApiGetMyMessage (params) {
  return post(`${baseUrl}student/message`, params);
}

// 意见反馈
function ApiSendFeedback (params) {
  return post(`${baseUrl}student/feedback`, params);
}

// 修改用户头像
function ApichangeHead (params) {
  return post(`${baseUrl}student/updateImage`, params);
}

// 修改用户密码
function ApiUpdatePassword (params) {
  return post(`${baseUrl}student/updatePassword`, params);
}

// 获取用户直播列表
function ApiLiveList (params) {
  return post(`${baseUrl}live/list`, params);
}
// 获取直播播放详情
function ApigetLiveInfo (params) {
  return get(`${baseUrl}live/liveInfo`, params);
}


export {
	ApiGetUserInfo,
  ApiGetTaskList,
  ApiGetCheckLesson,
  ApiSaveCourseProcess,
  ApiMyCollect,
	ApiStudentRecord,
  ApiGetMyMessage,
  ApiSendFeedback,
  ApichangeHead,
  ApiUpdatePassword,
  ApiLiveList,
	ApigetLiveInfo
}



// WEBPACK FOOTER //
// ./src/net/accound/index.js